const measureScriptLoadingTime = () => {
    performance.getEntriesByType('resource').forEach(function (entry) {
        if (entry.initiatorType === 'script') {
            console.log(`Script ${entry.name} took ${entry.duration} milliseconds to load.`);
        }
    });
};

measureScriptLoadingTime();